import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { DaysState } from "../../types/types";

export const getDays = createAsyncThunk<string[]>(
  "days/getDays",
  async () => {
    const API_URL = process.env.REACT_APP_URL_BACKEND!;
    const response = await fetch(`${API_URL}/api/v1/disabled_days/`);

    if (!response.ok) throw new Error("Не удалось получить список дней");

    return await response.json();
  }
)

const initialState: DaysState = {
  dates: [],
  loading: false,
  error: null,
};

const daysSlice = createSlice({
  name: "days",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDays.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDays.fulfilled, (state, action) => {
        state.loading = false;
        state.dates = action.payload;
      })
      .addCase(getDays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default daysSlice.reducer;
